module.exports = __webpack_public_path__ + "static/media/COLA2018002.4e97bc9c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/COLA2018002.pdf
// module id = 2265
// module chunks = 1